export function mergeLocations(allLocationsWithDetails) {
  let mergedLocations = [];
  //merge cmfs for locations having same entityId
  let allEntityIds = allLocationsWithDetails && allLocationsWithDetails.map(location => location.entityId);
  allEntityIds = [...new Set(allEntityIds)];
  allEntityIds.forEach(entityId => {
    let matchingLocations = allLocationsWithDetails.filter(location => location.entityId === entityId);
    if(matchingLocations.length > 1) {
      let cmfs = [...new Set(matchingLocations.map(location => location.cmfNumber))];
      let commonLocation = {
        cmfNumber: cmfs,
        entityId: matchingLocations[0].entityId,
        partyName: matchingLocations[0].partyName,
        canPurchase: matchingLocations[0].canPurchase,
        bucode: matchingLocations[0].bucode,
        orgId: matchingLocations[0].orgId,
        name: matchingLocations[0].orgName,
        status: matchingLocations[0].status,
        addresses: matchingLocations[0].addresses,
        storeId: matchingLocations[0].storeId
      };
      mergedLocations.push(commonLocation);
    }
    else {
      mergedLocations.push(matchingLocations[0]);
    }
  });
  return mergedLocations;
}
